import { Type } from "../Type";
export function islyFunction() {
    return new IslyFunction();
}
export class IslyFunction extends Type {
    class = "function";
    constructor() {
        super("function");
    }
    is = (value) => !!(value && typeof value == "function");
}
//# sourceMappingURL=index.js.map